import "./ToggleTabs.css";

import { ToggleTabsList } from "../../../models";
import { useToggleTabs } from "./useToggleTabs";

interface ToggleTabsProps {
  toggleTabsList: ToggleTabsList;
  onChange: (value: string) => void;
  currentTab?: string;
  size?: "small" | "medium";
  variant?: "default" | "roundedSquare";
}

export const ToggleTabs = ({
  toggleTabsList,
  onChange,
  currentTab = toggleTabsList[0].label,
  size = "medium",
  variant = "default",
}: ToggleTabsProps): JSX.Element => {
  const { tabsRef, setValue, value } = useToggleTabs({ toggleTabsList, currentTab });

  return (
    <div className={`ToggleTabs ToggleTabs_size_${size} ToggleTabs_variant_${variant}`}>
      {/* eslint-disable-next-line no-return-assign */}
      <div className="ToggleTabs_indicator" ref={(el) => (tabsRef.current[toggleTabsList.length] = el)} />
      {toggleTabsList.map((tab, index) => (
        <div
          // eslint-disable-next-line no-return-assign
          ref={(el) => (tabsRef.current[index] = el)}
          key={tab.label}
          role="button"
          tabIndex={0}
          onClick={() => {
            setValue(tab.label);
            onChange(tab.label);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setValue(tab.label);
              onChange(tab.label);
            }
          }}
          className={`ToggleTabsTab${value === tab.label ? " ToggleTabsTab_active" : ""}`}
        >
          <p className="body2">
            {tab.label}
            {tab.count && <span className="CountSpan"> ({tab.count})</span>}
          </p>
        </div>
      ))}
    </div>
  );
};
